import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTodayAttendance } from "../actions/TodayAction";
import { Box, CircularProgress, Typography } from "@mui/material";
import HeaderBannerPage from "../components/HeaderBannerPage";
import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
import { format } from "date-fns";
import { useLocation } from "react-router-dom";

const TodayAttendance = () => {
  const dispatch = useDispatch();
  const { attendanceItems, loading } = useSelector((state) => state.todayAttendance);
  const [currentTime, setCurrentTime] = useState(new Date());
  const location = useLocation();
  const { department, role } = location.state || {};

  const getTodayDate = () => {
    const today = new Date();
    return format(today, "yyyy-MM-dd"); // Format date correctly
  };

  const formatTime = (time) => {
    return time.toLocaleTimeString();
  };

  useEffect(() => {
    const timeInterval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timeInterval);
  }, []);

  useEffect(() => {
    const date = getTodayDate();
    if (department && role) {
      dispatch(fetchTodayAttendance(date, department, role));
    }
  }, [dispatch, department, role]);

  return (
    <Box sx={{ padding: 0, margin: "0 auto" }}>
      <HeaderBannerPage />
      <Box sx={{ padding: "26px", maxWidth: "500px", margin: "0 auto", mt: -5 }}>
        {/* Today's Date and Time Display */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "bold",
              color: "#154C79",
              textTransform: "uppercase",
              letterSpacing: "2.2px",
              lineHeight: "1.5",
              mb: 2,
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            {` ${getTodayDate()}`}
          </Typography>
          {/* <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "bold",
              color: "#FF5733",
              fontFamily: "'Poppins', sans-serif",
              display: "inline-block",
              letterSpacing: "3px",
              lineHeight: "-5",
            }}
          >
            {formatTime(currentTime)} 
          </Typography> */}
        </Box>
        {/* Attendance List */}
        <Box sx={{ maxHeight: "500px", overflowY: "auto", marginTop: "30px" }}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
              <CircularProgress />
            </Box>
          ) : attendanceItems && attendanceItems.length > 0 ? (
            attendanceItems.map((item, index) => (
              <Box
                key={index}
                sx={{
                  padding: "10px",
                  borderRadius: "10px",
                  marginBottom: "12px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
                  backgroundColor: "#fff",
                  border: "1px solid #ddd",
                }}
              >
                {/* Row 1: Date, In-Time, and Out-Time */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                  {/* Date */}
                  {/* <Typography sx={{ color: "rgba(8,51,89,1)", fontWeight: "bold", flex: 1, textAlign: "left" }}>
                  {item.inDate}
                </Typography> */}
                  {/* In-Time */}
                  <Box sx={{ textAlign: "right", flex: 2 }}>
                    <Typography
                      sx={{
                        color: "#239B56",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "right",
                        justifyContent: "right",
                      }}
                    >
                      {item.inTime}
                      <FiArrowDownLeft size={15} color="#239B56" />
                    </Typography>
                  </Box>
                  {/* Out-Time */}
                  <Box sx={{ textAlign: "center", flex: 1 }}>
                    <Typography
                      sx={{
                        color: "#E74C3C",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {item.outTime}
                      <FiArrowUpRight size={15} color="#E74C3C" />
                    </Typography>
                  </Box>
                </Box>
                {/* Row 2: Service Number, Employee Name, and Image */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "8px" }}>
                  {/* Employee Image (moved to left side and enlarged) */}
                  <Box sx={{ flex: 0, textAlign: "left", display: "flex", justifyContent: "flex-start" }}>
                    <img
                      src={`https://esystems.cdl.lk/backend/AttendMe2/Home/GetDTSUserImg?serviceNo=${item.serviceNo}`}
                      alt={`User ${item.EmpName}`}
                      style={{
                        width: "80px", // Increased size of the image
                        height: "80px", // Increased size of the image
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "3px solid #ddd",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.5)",
                      }}
                      onError={(e) => (e.target.src = "/placeholder-image.jpg")} // Fallback image
                    />
                  </Box>
                  {/* Service Number and Employee Name */}
                  <Box
                    sx={{
                      display: "flex",         // Flexbox layout
                      flexDirection: "column", // Stack elements vertically
                      alignItems: "center",    // Center horizontally
                      justifyContent: "center", // Center vertically
                      marginBottom: "5px",     // Space below the box
                    }}>
                    {/* Service Number */}
                    <Typography sx={{ fontWeight: "bold", color: "#0C3C6D", pb:1 }}>
                      {item.serviceNo}
                    </Typography>
                    {/* Employee Name */}
                    <Typography sx={{ fontWeight: "bold", color: "#121212" }}>
                      {item.EmpName}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))
          ) : (
            <Typography variant="body1" sx={{ textAlign: "center", padding: "20px" }}>
              No attendance data available.
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default TodayAttendance;
